import * as z from "zod";

export const getContextualMetric = {
  name: "getContextualMetric" as const,
  input: z.object({
    fromDate: z.string(),
    toDate: z.string(),
    event: z.string(),
    aggregate: z.enum(["SUM", "AVG", "UNIQUE"]),
    compareToPriorPeriod: z.boolean(),
  }),
  output: z.object({
    value: z.number(),
    comparisonChangePercent: z.number().optional(),
  }),
};
